import { safeApiCall } from "api/common.service";
import { getDebtorSummary } from "api/debtor.service";
import { logError } from "api/diagnostic.service";
import { useEffect, useState } from "react";
import { useSessionStore } from "stores/userSessionStore";
import { DebtorSummaries } from "types/model.types";

interface UseDebtorFetchResult {
  debtors: DebtorSummaries;
  loading: boolean;
  error: string | null;
}

export const useProgressiveDebtorFetch = (): UseDebtorFetchResult & {
  refresh: () => void;
} => {
  const [debtors, setDebtors] = useState<DebtorSummaries>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const sessionVerified = useSessionStore((s: any) => s.sessionVerified);

  const fetchDebtors = async () => {
    try {
      setLoading(true);
      const response = await safeApiCall(getDebtorSummary());
      setDebtors(response ?? []);
    } catch (error) {
      logError(error);
      setError("Failed to fetch debtor records.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!sessionVerified) return;
    fetchDebtors();
  }, [sessionVerified]);

  return { debtors, loading, error, refresh: fetchDebtors };
};
